import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";


export async function deleteAllTransactionReportRequest(reportType?: number): Promise<any> {
  try {
    // Eğer reportType varsa payload ile gönder, yoksa null gönder
    const payload = reportType !== undefined ? { reportType } : null;
    return (await axiosInstance.post("/Transaction/DeleteAllReportRequestForUser", payload)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}